import React from "react";
import Container from "../ui/Container";
import Card from "../ui/Card";
import { ClipboardList, Wrench, Rocket } from "lucide-react";

function Step({ n, title, body, icon: Icon }) {
  return (
    <Card className="p-7 sm:p-8">
      <div className="flex items-start justify-between gap-6">
        <div>
          <div className="text-xs font-semibold tracking-wider text-white/50">STEP {n}</div>
          <div className="mt-2 text-xl font-semibold text-white">
            {title}<span className="text-cyan-300">.</span>
          </div>
          <p className="mt-3 text-sm leading-6 text-white/65">{body}</p>
        </div>
        <div className="grid h-11 w-11 place-items-center rounded-2xl border border-white/10 bg-white/[0.03]">
          <Icon className="h-5 w-5 text-cyan-300" />
        </div>
      </div>
    </Card>
  );
}

export default function DedicatedHowItWorks() {
  return (
    <section className="bg-[#070A0F] py-20">
      <Container>
        <div className="mx-auto max-w-4xl text-center">
          <div className="text-xs font-semibold tracking-wider text-white/50">PROCESS</div>
          <h2 className="mt-3 text-balance text-4xl font-semibold leading-[0.95] tracking-tight text-white sm:text-5xl">
            Simple provisioning<span className="text-cyan-300">.</span>
          </h2>
          <p className="mx-auto mt-5 max-w-2xl text-white/70 sm:text-lg">
            Choose hardware, confirm billing cycle, and we’ll get you online fast.
          </p>
        </div>

        <div className="mt-14 grid grid-cols-1 gap-6 lg:grid-cols-3">
          <Step n="01" icon={ClipboardList} title="Choose your server" body="Pick the hardware that matches your workload and growth plan." />
          <Step n="02" icon={Wrench} title="Configure & deploy" body="We’ll provision, apply network protection, and help with any setup you need." />
          <Step n="03" icon={Rocket} title="Scale responsibly" body="Upgrade when required — move to higher tier hardware without guessing." />
        </div>
      </Container>
    </section>
  );
}
